// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import * as React from 'react';
import { Dropdown, IDropdownOption, IDropdownStyles } from 'office-ui-fabric-react';
import { sharedDropdownStyles } from 'src/helpers/sharedDropdownStyles';
import { useTranslation } from 'react-i18next';
import Styles from './styles.module.scss';

interface SoftwareSupportProps {
    onSdtToolRanChange: (option: IDropdownOption | undefined) => void;
    onTypeOfResolutionChange: (option: IDropdownOption | undefined) => void;
    sdtToolRan?: IDropdownOption;
    typeOfResolution?: IDropdownOption;
}

export default function softwareSupport(props: SoftwareSupportProps) {
    const { t } = useTranslation();

    const options: IDropdownOption[] = [
        { key: 'yes', text: t('yes') },
        { key: 'no', text: t('no') },
    ];

    const resolutionOptions: IDropdownOption[] = [
        { key: 'simple_resolution', text: t('simple_resolution') },
        { key: 'high_level_resolution', text: t('high_level_resolution') },
    ];

    const localDropdownStyles: Partial<IDropdownStyles> = {
        title: {
            selectors: {
                '@media (forced-colors: active)': {
                    backgroundColor: 'Canvas',
                    color: 'CanvasText',
                    borderColor: 'CanvasText',
                    forcedColorAdjust: 'none',
                },
            },
        },
        caretDownWrapper: {
            selectors: {
                '@media (forced-colors: active)': {
                    backgroundColor: 'transparent',
                    forcedColorAdjust: 'none',
                },
            },
        },
        caretDown: {
            selectors: {
                '@media (forced-colors: active)': {
                    color: 'inherit',
                    forcedColorAdjust: 'none',
                },
            },
        },
    };

    const dropdownStyles: Partial<IDropdownStyles> = {
        ...sharedDropdownStyles,
        ...localDropdownStyles,
        root: { marginTop: 20 },
        dropdown: { width: 300 },
    };

    const resolutionDropdownStyles: Partial<IDropdownStyles> = {
        ...sharedDropdownStyles,
        ...localDropdownStyles,
        dropdown: { width: 300 },
        root: {
            marginTop: 20,
            marginLeft: 100,
        },
    };

    function onSdtToolRanChange(event: any, option: IDropdownOption | undefined) {
        props.onSdtToolRanChange(option);
    }

    function onTypeOfResolutionChange(event: any, option: IDropdownOption | undefined) {
        props.onTypeOfResolutionChange(option);
    }

    return (
        <div className={Styles.softwareDropdownContainer}>
            <Dropdown
                id="sdt-tool-ran-id"
                label={t('sdt_tool_ran')}
                options={options}
                styles={dropdownStyles}
                onChange={onSdtToolRanChange}
                required={true}
                className={Styles.contrastThemeStyles}
            />
            <Dropdown
                id="software-resolution-type-id"
                label={t('type_of_resolution')}
                options={resolutionOptions}
                styles={resolutionDropdownStyles}
                onChange={onTypeOfResolutionChange}
                required={true}
                className={Styles.contrastThemeStyles}
            />
        </div>
    );
}